/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateContributorRequest
 */
export interface UpdateContributorRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContributorRequest
     */
    active?: boolean;
}

/**
 * Check if a given object implements the UpdateContributorRequest interface.
 */
export function instanceOfUpdateContributorRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateContributorRequestFromJSON(json: any): UpdateContributorRequest {
    return UpdateContributorRequestFromJSONTyped(json, false);
}

export function UpdateContributorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContributorRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
    };
}

export function UpdateContributorRequestToJSON(value?: UpdateContributorRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
    };
}

